import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sainik-reports-pages',
  templateUrl: './sainik-reports-pages.component.html',
  styleUrls: ['./sainik-reports-pages.component.css']
})
export class SainikReportsPagesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/sainik-reports/sainik-reports-pages/sainik-reports-pages.component.ts